import { UsedRedCards } from "../classes/UsedRedCards";
import { blackCards } from "../constants/BlackCards";
import { NUM_OF_TRIES } from "../constants/Constants";
import { redCards } from "../constants/RedCard";

export const getBlackCardIndex = (usedCardIndices: number[]) => {
    const cards = blackCards;
    for (let tryNum = 0; tryNum < NUM_OF_TRIES; tryNum++) {
      const cardIdx = Math.floor(Math.random() * cards.length);
      if (!usedCardIndices.includes(cardIdx)) {
        return cardIdx;
      }
    }
    for (let idx = 0; idx < cards.length; idx++) {
      if (!usedCardIndices.includes(idx)) {
        return idx;
      }
    }
    
    // no more black cards - empty the used black cards array and start over
    usedCardIndices = [];
    return Math.floor(Math.random() * cards.length);
}

export const getRedCardIndex = async (gameId: string) =>
{
  const cards = redCards;
  const usedRedCards = await UsedRedCards.getUsedRedCards(gameId);
  for (let tryNum = 0; tryNum < NUM_OF_TRIES; tryNum++) {
    const cardIdx = Math.floor(Math.random() * cards.length);
    if (!usedRedCards.indices.includes(cardIdx)) {
      usedRedCards.indicesStr += String(cardIdx) + ",";
      await UsedRedCards.updateUsedRedCards(gameId, usedRedCards.indicesStr);
      return cardIdx;
    }
  }
  for (let idx = 0; idx < cards.length; idx++) {
    if (!usedRedCards.indices.includes(idx))
    {
      usedRedCards.indicesStr += String(idx) + ",";
      await UsedRedCards.updateUsedRedCards(gameId, usedRedCards.indicesStr);
      return idx;
    }
  }

  // no more cards - empty used cards array and pick a random card
  const cardIdx = Math.floor(Math.random() * cards.length);
  await UsedRedCards.updateUsedRedCards(gameId, String(cardIdx) + ",");
  return cardIdx;
}